import { render, staticRenderFns } from "./add_order.vue?vue&type=template&id=2a43c6f9&scoped=true&"
import script from "./add_order.vue?vue&type=script&lang=js&"
export * from "./add_order.vue?vue&type=script&lang=js&"
import style0 from "./add_order.vue?vue&type=style&index=0&id=2a43c6f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a43c6f9",
  null
  
)

export default component.exports